import DownloadGdDlysjgLocateHistoryModal from './download-gd-dlysjg-locate-history-modal.vue'
export default DownloadGdDlysjgLocateHistoryModal
